import Vue from 'vue'

export const invoicePrint = async function(invoice) {
  // Only add info if retail product on invoice
  if (!invoice.lines.some(line => line.type === 'Product'))
    return '';

  let results = await Vue.prototype.$apiCall(`query OntarioInvoicePrint($id:ID!) {
                                                  customer(id:$id) {type}
                                                }`, {id:invoice.customerId});

  if ('Licensee.TiedHouse.ByTheGlass'.includes(results.data.customer.type)) {
    results = await Vue.prototype.$apiCall(`query OntarioInvoicePrint($id:ID!) {
      ontarioInvoiceLicenseeBreakdown(id:$id) {totalDeposit,totalDiscount,totalMarkup,totalHST}
    }`, {id:invoice.id});
    const breakdown = results.data.ontarioInvoiceLicenseeBreakdown;


    return `<div>Deposit included: ${Vue.prototype.$currency(breakdown.totalDeposit)}, Licensee discount: ${Vue.prototype.$currency(breakdown.totalDiscount)}, HST included: ${Vue.prototype.$currency(breakdown.totalHST)}</div>
            <div>THIS SALE IS MADE ON BEHALF OF THE LCBO (HST #R122241177), NOT THE DISTILLERY</div>`;
  }

  else if (results.data.customer.type === 'None')
    return `<div>All alcohol products have HST, bottle deposit, Ontario Spirits Taxes and Federal Excise Tax included</div>
            <div>(See http://www.fin.gov.on.ca/en/tax/st/infosheet.html for more information.)</div>`;

  return ``;
}